import { Link } from "react-router-dom"

function SWC() {
    return (
        <div>
            <div className="text-center max-w-4xl mx-auto px-6 py-12">
                <div>
                    <h1 className="swc-title text-5xl font-bold text-navy">Why Choose Summer Wonder Camp?</h1>
                </div>
                <div>
                    <ul className="swc-list mt-10">
                        <div className="swc-box text-base bg-stone-100 shadow hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out border-t-4 border-b-4 border-navy/50 h-[115px] w-full flex flex-col items-center justify-center p-4">
                            <p className="swc-p-titles text-xl font-bold">☀️ Engaging Activities ☀️</p>
                            <ul>
                                <li>Kids will enjoy a variety of hands-on learning experiences, games, arts & crafts, and themed activities.</li>
                            </ul>
                        </div>
                        
                        <div className="swc-box text-base mt-10 bg-stone-100 shadow hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out border-t-4 border-b-4 border-navy/50 h-[115] w-full flex flex-col items-center justify-center p-4">
                            <p className="text-xl font-bold">🎒 Exciting Field Trips 🎒</p>
                            <ul >
                                <li>Adventure awaits with off-site trips that spark curiosity and exploration.</li>
                            </ul>
                        </div>
                        
                        <div className="swc-box text-base mt-10 bg-stone-100 shadow hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out border-t-4 border-b-4 border-navy/50 h-[115px] w-full flex flex-col items-center justify-center p-4">
                            <p className="text-xl font-bold">🏆 Field Days & Team Challenges 🏆</p>
                            <ul>
                                <li>Encourage teamwork and sportsmanship with friendly competitions.</li>
                            </ul>
                        </div>
                        
                        <div className="swc-box text-base mt-10 bg-stone-100 shadow hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out border-t-4 border-b-4 border-navy/50 h-[115px] w-full flex flex-col items-center justify-center p-4">
                            <p className="text-xl font-bold">✝️ Faith-Based Fun ✝️</p>
                            <ul>
                                <li>Daily devotionals and interactive Bible lessons help children deepen their relationship with Jesus.</li>
                            </ul>
                        </div>
                        
                        <div className="swc-box text-base mt-10 bg-stone-100 shadow hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out border-t-4 border-b-4 border-navy/50 h-[115px] w-full flex flex-col items-center justify-center p-4">
                            <p className="text-xl font-bold">🎭 Creative Expression 🎭</p>
                            <ul>
                                <li>Music, drama, and storytelling bring the camp experience to life!</li>
                            </ul>
                        </div>
                    
                    </ul>
                </div>
            </div>

            <div className="responsive-column flex justify-center items-start gap-8 px-6 py-12">
                <div className="text-center w-1/2 px-6 py-12">
                    <h1 className="swc-join-title text-5xl font-bold text-navy">Who Can Join?</h1>
                    <p className="swc-join text-lg mt-5">Children ages 5-12 are invited to be part of this transformative summer adventure!</p>
                </div>

                <div className="text-center w-1/2 px-6 py-12">
                    <h1 className="swc-reg-title text-5xl font-bold text-navy">How to Register?</h1>
                    <p className="swc-reg text-lg mt-5">Click on the link below to secure your child’s spot today!</p>
                    <Link to="https://form.jotform.com/250566177744162">
                        <button className="swc-reg-button text-base mt-5 font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out">
                            REGISTER NOW
                        </button>
                    </Link>
                </div>
            </div>

            <div className="responsive-column flex justify-center items-start gap-8">
                <div className="text-center w-1/2 mb-20">
                    <p className="swc-join-us text-xl font-bold">Join us for a summer filled with faith, friendship, and unforgettable fun!</p>
                </div>
            </div>



        </div>
    )
}

export default SWC